import React, { useEffect, useState } from 'react';
import { isValidEmail } from '../../../utils/helper';
import CountriesSelect from '../../global-components/countriesSelect';
import ProvincesSelect from '../../global-components/provincesSelect';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import { AddSaveBrokerDto } from '../../../types';
import { getProvinces } from '../../../api/shipmentForms';
import { setProvincesList } from '../../../redux/app/appActions';
interface Props {
  formData: AddSaveBrokerDto;
  setFormData: any;
  formValidations: any;
  setFormValidations: any;
  validating: boolean;
}
function BrokerFields({
  formData,
  setFormData,
  formValidations,
  setFormValidations,
  validating,
}: Props) {
  const { provincesList } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const dispatch = useDispatch<any>();
  const [provinces, setProvinces] = useState<any>(provincesList);
  const [isCountryChanged, setIsCountryChanged] = useState(false);

  useEffect(() => {
    getProvinces(formData.address.country)
      .then((data) => {
        setProvinces(data?.data?.content);
        dispatch(setProvincesList(data?.data?.content));
        if (isCountryChanged) {
          setFormData({
            ...formData,
            address: {
              ...formData.address,
              province: data?.data?.content[0]?.code,
            },
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [formData.address.country, dispatch]);

  return (
    <div className='row mt-4'>
      <div className='col-sm-12 col-md-6 col-lg-4'>
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_name'
          >
            Broker Name{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_name'
              className={`form-control ubbe-input ${
                validating && formData.contact.name !== ''
                  ? 'is-valid'
                  : validating && formData.contact.name === ''
                  ? 'is-invalid'
                  : ''
              } ${
                formData.contact.name && !validating ? 'highlighted-border' : ''
              }`}
              maxLength={30}
              autoComplete='new-password'
              placeholder='Broker Name'
              value={formData.contact.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  company_name: e.target.value !== '',
                  name: e.target.value !== '',
                });
                setFormData({
                  ...formData,
                  contact: {
                    ...formData.contact,
                    name: e.target.value,
                    company_name: e.target.value,
                  },
                });
              }}
            />
            {validating && formData.contact.name === '' && (
              <div className='error_text'>
                Please provide a valid broker name.
              </div>
            )}
          </div>
        </div>
        {/* Country */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_country'
          >
            Country{' '}
          </label>
          <div className='col-12'>
            <CountriesSelect
              onSelect={(val: any) => {
                setFormData({
                  ...formData,
                  address: {
                    ...formData.address,
                    country: val,
                    province: '',
                  },
                });
                if (val) {
                  setIsCountryChanged(true);
                }
              }}
              selectedCountry={formData?.address?.country}
            />
          </div>
        </div>
        {/* Address */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_address'
          >
            Address{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_address'
              className={`form-control ubbe-input ${
                validating && formData.address.address !== ''
                  ? 'is-valid'
                  : validating && formData.address.address === ''
                  ? 'is-invalid'
                  : ''
              } ${
                formData.address.address && !validating
                  ? 'highlighted-border'
                  : ''
              }`}
              maxLength={30}
              autoComplete='new-password'
              placeholder='123 Address Road'
              value={formData.address.address}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  address: e.target.value !== '',
                });
                setFormData({
                  ...formData,
                  address: {
                    ...formData.address,
                    address: e.target.value,
                  },
                });
              }}
            />
            {validating && formData.address.address === '' && (
              <div className='error_text'>Please provide a valid address</div>
            )}
          </div>
        </div>
      </div>
      <div className='col-sm-12 col-md-6 col-lg-4'>
        {/* Email */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_email'
          >
            Email{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_email'
              className={`form-control ubbe-input ${
                validating && isValidEmail(formData.contact.email)
                  ? 'is-valid'
                  : validating && !isValidEmail(formData.contact.email)
                  ? 'is-invalid'
                  : ''
              }  ${
                formData.contact.email && !validating
                  ? 'highlighted-border'
                  : ''
              }`}
              maxLength={100}
              autoComplete='new-password'
              placeholder='email@eemail.com'
              value={formData.contact.email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  email: isValidEmail(e.target.value),
                });
                setFormData({
                  ...formData,
                  contact: {
                    ...formData.contact,
                    email: e.target.value,
                  },
                });
              }}
            />
            {validating && !isValidEmail(formData.contact.email) && (
              <div className='error_text'>
                Please provide a valid broker email.
              </div>
            )}
          </div>
        </div>
        {/* Province */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_province'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='State, Region'
          >
            Province{' '}
          </label>
          <div className='col-12'>
            <ProvincesSelect
              onSelect={(val: any) => {
                setFormData({
                  ...formData,
                  address: {
                    ...formData.address,
                    province: val,
                  },
                });
              }}
              provincesList={provinces}
              selectedProvince={formData?.address.province}
            />
          </div>
        </div>
        {/* Postal Code */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_postal_code'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Postal Code, Zip Code, Pin Code, Mailing Code.'
          >
            Postal Code{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_postal_code'
              className={`form-control ubbe-input ${
                validating && formData.address.postal_code !== ''
                  ? 'is-valid'
                  : validating && formData.address.postal_code === ''
                  ? 'is-invalid'
                  : ''
              } ${
                formData.address.postal_code && !validating
                  ? 'highlighted-border'
                  : ''
              }`}
              maxLength={30}
              autoComplete='new-password'
              placeholder='Postal Code, Zip Code, Pin Code, Mailing Code.'
              value={formData.address.postal_code}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  postal_code: e.target.value !== '',
                });
                setFormData({
                  ...formData,
                  address: {
                    ...formData.address,
                    postal_code: e.target.value,
                  },
                });
              }}
            />
            {validating && formData.address.postal_code === '' && (
              <div className='error_text'>
                Please provide a valid postal_code.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='col-sm-12 col-md-6 col-lg-4'>
        {/* City */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_city'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Municipality, Community, Town, or Village'
          >
            City{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_city'
              className={`form-control ubbe-input ${
                validating && formData.address.city !== ''
                  ? 'is-valid'
                  : validating && formData.address.city === ''
                  ? 'is-invalid'
                  : ''
              } ${
                formData.address.city && !validating ? 'highlighted-border' : ''
              }`}
              maxLength={30}
              autoComplete='new-password'
              placeholder='Municipality, Community, Town, or Village'
              value={formData.address.city}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  city: e.target.value !== '',
                });
                setFormData({
                  ...formData,
                  address: {
                    ...formData.address,
                    city: e.target.value,
                  },
                });
              }}
            />
            {validating && formData.address.city === '' && (
              <div className='error_text'>Please provide a valid city.</div>
            )}
          </div>
        </div>
        {/* Phone */}
        <div className='row mb-3'>
          <label
            className='col-sm-12 col-form-label globalInputLabel my-auto'
            htmlFor='broker_phone'
          >
            Phone{' '}
          </label>
          <div className='col-12'>
            <input
              id='broker_phone'
              className={`form-control ubbe-input ${
                validating && formData.contact.phone !== ''
                  ? 'is-valid'
                  : validating && formData.contact.phone === ''
                  ? 'is-invalid'
                  : ''
              } ${
                formData.contact.phone && !validating
                  ? 'highlighted-border'
                  : ''
              }`}
              autoComplete='new-password'
              placeholder='1112223333'
              minLength={10}
              maxLength={15}
              value={formData.contact.phone}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormValidations({
                  ...formValidations,
                  phone: e.target.value.length > 9,
                });
                setFormData({
                  ...formData,
                  contact: {
                    ...formData.contact,
                    phone: e.target.value.replace(/[^0-9]/g, ''),
                  },
                });
              }}
            />
            {validating && formData.contact.phone.length < 10 && (
              <div className='error_text'>
                Please provide a valid phone number.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrokerFields;
